export default __webpack_public_path__ + "static/media/D_Breakfast.b5babaf0.svg";